import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  forwardRef,
  inject,
  Input,
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

export const MLK_TEXT_AREA_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => MlkTextAreaGroup),
  multi: true,
};

@Component({
  selector: 'mlk-text-area-group',
  templateUrl: './text-area-group.component.html',
  styleUrls: ['./text-area-group.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [MLK_TEXT_AREA_VALUE_ACCESSOR],
  standalone: true,
})
export class MlkTextAreaGroup implements ControlValueAccessor {
  private cdr = inject(ChangeDetectorRef);

  @Input() public value = '';
  @Input() public min = '';
  @Input() public max = '';
  @Input() public label = '';
  @Input() public placeholder = '';
  @Input() public id = '';
  @Input() public name = '';

  public disabled = false;

  public _onTouched: () => void = () => {};
  public _onChange: (value: string) => void = () => {};

  public writeValue(value: string): void {
    this.value = value ?? '';
    this.cdr.markForCheck();
  }

  public registerOnChange(fn: (value: string) => void): void {
    this._onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this._onTouched = fn;
  }

  public setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
    this.cdr.markForCheck();
  }

  /** appelé par (input) */
  public onInput(event: Event): void {
    const target = event.target as HTMLTextAreaElement | null;
    const value = target?.value ?? '';

    this.value = value;
    this._onChange(value);
    this.cdr.markForCheck();
  }

  /** appelé par (blur) */
  public onBlur(): void {
    this._onTouched();
  }
}
